import {
  UPDATE_SURVEYS_LIST,
  TOGGLE_SURVEYS_LIST_LOADING,
  SURVEYS_LIST_ERROR,
  SURVEYS_UPDATE_TOTAL_LIST,
} from "../actions/dataEntrySurveyActions";

const initState = {
  name: "Data Entry Surveys",
  surveys: {
    loading: true,
    list: [],
    error: null,
    totalRecords: 0,
  },
};

const dataEntrySurveyReducer = (state = initState, action) => {
  const newState = { ...state };

  switch (action.type) {
    case UPDATE_SURVEYS_LIST:
      newState.surveys.list = action.payload.value;
      break;
    case SURVEYS_UPDATE_TOTAL_LIST:
      newState.surveys.totalRecords = action.payload.value;
      break;
    case TOGGLE_SURVEYS_LIST_LOADING:
      newState.surveys.loading = action.payload.value;
      break;
    case SURVEYS_LIST_ERROR:
      newState.surveys.error = action.payload.value;
      break;
    default:
      break;
  }
  return newState;
};

export default dataEntrySurveyReducer;
